<template>
  <div class="winding-section">
    <accordion-panel
      id="winding-section"
      class="winding-section__accordion avoid-break"
      :collapsed.sync="collapsed"
    >
      <template #title>
        <strong> {{ $t('general.winding') }} {{ windingId }} </strong>
      </template>
      <div v-if="!loading">
        <b-row class="winding-section__content-row">
          <b-col
            class="pr-md-0 mb-3 mb-md-0"
            cols="12"
            lg="4"
          >
            <time-left-card :time-left="timeLeft"/>
          </b-col>
          <b-col
            class="mb-3 mb-md-0"
            cols="12"
            lg="8"
          >
            <additional-information-card
              :winding="winding"
            />
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <s-loader
          class="py-5"
          size="lg"
        />
      </div>
    </accordion-panel>
  </div>
</template>

<script>
import AdditionalInformationCard
  from '@/domain/components/installation/engineering/finalGradient/AdditionalInformationCard';
import AccordionPanel from '@/components/AccordionPanel';
import TimeLeftCard from '@/domain/components/installation/engineering/finalGradient/TimeLeftCard';

export default {
  name: 'WindingSection',
  props: {
    winding: {
      type: Object,
      default: () => ({}),
    },
    windingId: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AdditionalInformationCard,
    AccordionPanel,
    TimeLeftCard,
  },
  data: () => ({
    collapsed: false,
  }),
  computed: {
    timeLeft() {
      return (this.winding || {}).timeLeft;
    },
  },
};
</script>
<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.winding-section
  &__content-row > div
    display: inline-flex
    flex: 1

::v-deep
  .accordion-panel
    &__header
      padding: 2px 15px !important
      font-weight: bold

@media print
  .winding-section
    &__content-row > div:first-child
      padding-right: 0
      flex: 0 0 33.33333%
      max-width: 33.33333%

    &__content-row > div:last-child
      flex: 0 0 66.66667%
      max-width: 66.66667%
</style>

